import { createMultipleParam } from '@appscience/utils'
import { indexBy, prop } from 'ramda'
import { API_URL } from 'src/config/environment'
import { ArchivePackage } from '../../../views/warehouse/from-warehouse/archive/model/atoms'
import apiCreator from '../../api-creator'
import { Api_PackageAndShipment } from '../../common/shipment-model'
import { handleErrorWithDefaultValue } from '../../common/utils'
import { parseDate } from '@app/utils/date'

interface Params {
  warehouseIds: Array<string>
}

export function getArchivePackages({
  warehouseIds,
}: Params): Promise<Record<string, ArchivePackage>> {
  return apiCreator
    .get(
      `${API_URL.TWIN}/packages?${createMultipleParam(
        warehouseIds,
        'from_warehouse_id',
      )}&shipment_status=archive`,
    )
    .then(res => {
      const rawData: Array<Api_PackageAndShipment> = res.data.packages
      return indexBy(prop('id'), rawData.map(remapToArchivePackage))
    })
    .catch(handleErrorWithDefaultValue({}))
}

export function remapToArchivePackage({
  package: packageData,
  shipment,
}: Api_PackageAndShipment): ArchivePackage {
  return {
    id: packageData.id,
    departureDate: parseDate(shipment.departure_date),
    trackIds: shipment.track_number,
    invoiceNumber: packageData.package_invoice,
    arrivalDate: parseDate(shipment.arrival_date),
    packageComment: packageData.provider_comments,
    toWarehouseId: shipment.to_warehouse_id,
    transporter: shipment.transporter,
    temperatures: packageData.temperature,
    isHazmat: packageData.hazmat,
    currencyId: packageData.currency,
    invoicePriceSum: packageData.package_sum,
    quantity: packageData.items_quantity,
    tag: shipment.tag,
    boxNumber: packageData.box_numbers,
    providerTagToHub: packageData.provider_tag_to_hub,
    providerTagToRu: packageData.provider_tag_to_ru,
    providerTagToTransit: packageData.provider_tag_to_transit,
  }
}
